module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/msysov2-7c01493cb0ea3facd53a2d116eca7ee4.jpg";